import React, { useRef, useState } from 'react'
import { Container } from './styles';
import { Form } from '@unform/web';
import Input from '../../components/Input'
import { ToastContainer, toast } from 'react-toastify';

import Certification from '../../components/Certification';

import Enrolled from '../../data/enrolled.json'

export default function Certificado() {
    const formRef = useRef(null);
    const [screen, setScreen] = useState(1);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState('');

    async function handleSubmit(data) {
        let userCheck = false;
        try{
            setLoading(true);
            await Enrolled.map(e => {
                if(data.email === e.EMAIL) {
                    setName(e.NOME);
                    setScreen(screen+1);
                    userCheck = true;
                };
            });
            setLoading(false);
            if(userCheck === false){
                toast.error('Inscrição não encontrada', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    });
                    
            } 
            // setName(data.name);
        } catch (err) {
            console.log('erro', err);
        };
    };

    return (
        <Container>
            <content>
                <h1>
                    Emissão de Certificado ExpoPrev & AGOPREV 2023 - 5ª Edição / 3ª Edição
                </h1>
                <br/>
                <p>Em caso de dúvidas, basta entrar em contato pelo (62) 98100-0025 ou enviar para contato@expoprev.com.br. 
                </p>
                <br/>
                {screen === 1 &&
                    <Form ref={formRef} onSubmit={handleSubmit}>
                        <>                             
                            <p>Qual seu email de inscrição?</p>
                                <Input name="email" type="email" placeholder="" required/>
                                <br/>
                                <br/>
                            {loading ? 
                                <>
                                    <aside>
                                        <button type="button">Carregando...</button>
                                    </aside>
                                </>
                            : 
                                <>
                                    <aside>
                                        <button type="submit">Gerar Certificado</button>
                                    </aside>
                                </>
                            }
                        </>
                    </Form>
                }
                {screen === 2 &&
                    <>
                        <Certification name={name}/>
                    </>
                }
            </content>
            <br/>
            <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            />
            <ToastContainer />
        </Container>
    )
}